import { PulsePersona } from "@swivl-mono/types";
import { BasicSelect } from "@swivl-mono/ui";

import { NO_PULSE_PERSONA, memberPersonaOptions, personaFromOption } from "../../../AIStudio/Testing/PulsePreview.Helpers";

const OPTIONS = memberPersonaOptions();

interface PulsePersonaSelectProps {
  persona: PulsePersona | null;
  disabled?: boolean;
  onChange: (persona: PulsePersona | null) => void;
}

/** A member's or invite's Pulse persona: what their Pulse page is about (ENG-3433). */
export function PulsePersonaSelect(props: PulsePersonaSelectProps): React.ReactElement {
  const { persona, disabled, onChange } = props;

  const handleChange = (values: string[]): void => {
    const next = personaFromOption(values[0]);
    if (next !== persona) onChange(next);
  };

  return (
    <BasicSelect
      label="Pulse persona"
      selectedValues={[persona ?? NO_PULSE_PERSONA]}
      options={OPTIONS}
      onChange={handleChange}
      hideClear
      disabled={disabled}
    />
  );
}
